export { GoogleTagManager, push } from "./GoogleTagManager"
